import { Store } from 'src/state/store.type';

export const selectLastInitialCacheSynced = ({ cache }: Store): number | undefined => {
	return cache.lastSyncedInitialData;
};

export const selectLastAuthenticatedCacheSynced = ({ cache }: Store): number | undefined => {
	return cache.lastSyncedAuthenticatedData;
};
